import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setActiveSidebar } from "states/app-setting/app-setting.action";
import { getAllCustomerAddressApi, removeCustomerAddressApi } from "states/customer-address/customer-address.api";
import { CustomerAddressModel } from "states/customer-address/customer-address.models";
import { globalValueSetToast, globalValueShowConfirmModal } from "states/global-value/global-value.action";
import { ConfirmModel, ToastModel, ToastType } from "states/global-value/global-value.models";
import "./address.less";

interface AddressProps {}
const Address = (props: AddressProps) => {
  const dispatch = useDispatch();
  const [customerAddressList,setCustomerAddressList] = useState<CustomerAddressModel[]>([]);
  document.title = "Danh sách địa chỉ";
  
  const _handleGetCustomerAddress = async () =>{
      try{
        let result = await getAllCustomerAddressApi();
        setCustomerAddressList(result.data);
      }
      catch(error){
        dispatch(
            globalValueSetToast({
                message: error?.response?.data?.error?.message,
                type: ToastType.error,
              } as ToastModel)
            );
      }
  }
  const _handleRemove = async (id: number | string) =>{
    try{
      dispatch(
        globalValueShowConfirmModal({
          isModal: true,
          message: "Bạn có muốn xóa dữ liệu không?",
          onYes: async (ev: any) => {
            ev.preventDefault();
            await removeCustomerAddressApi(id);
            dispatch(globalValueShowConfirmModal({isModal: false}));
            await _handleGetCustomerAddress();
          },
          onClose: async (ev: any) => {
              ev.preventDefault();
             dispatch(globalValueShowConfirmModal({isModal: false}));
           },
        } as ConfirmModel)
      );
    }
    catch(error){
      dispatch(
        globalValueSetToast({
            message: error?.response?.data?.error?.message,
            type: ToastType.error,
          } as ToastModel)
        );
    }
  }
  useEffect(() => {
    _handleGetCustomerAddress();
    dispatch(setActiveSidebar("address"));
  }, []);
  return (
    <React.Fragment>
      <div className="head">Danh sách địa chỉ</div>
      <Link className="add-btn" to={`/account/addresses/add`}>
        <span className="nac-plus" /> Thêm địa chỉ mới
      </Link>
      <div className="content">
        {customerAddressList && customerAddressList.map((address) => (
          <div className="address-item">
            <div className="info">
              <div className="name-t">
              <span className="text-gray text-bold">Họ và tên: </span>{" "}
              {address?.name}
              </div>
              <div className="phone">
              <span className="text-gray text-bold">Số điện thoại: </span>{" "}
                {address?.phoneNumber}
              </div>
              <div className="address">
                <span className="text-gray text-bold">Địa chỉ: </span>{" "}
                {`${address?.address}, ${address?.wardName}, ${address?.districtName}, ${address?.provinceName}`}
              </div>
            </div>
            <div className="action">
              <Link to={`/account/addresses/edit/${address.id}`}>Chỉnh sửa</Link>
              <button className="remove-btn" onClick={()=> _handleRemove(address.id)}>Xóa</button>
            </div>
          </div>
        )) }
      </div>
    </React.Fragment>
  );
};
export default Address;
